import { IAssignee, AssigneeActions, IAssigneesStoreState } from "@gtmhub/assignees";
import { GtmhubController } from "@gtmhub/core";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { INgRedux } from "@gtmhub/state-management";
import { ITeam, TeamService } from "@gtmhub/teams";
import { IdMap } from "@gtmhub/util";
import { IController, IComponentOptions, IWindowService, IQService, IPromise } from "angular";

const bindStateToCtrl = (state: IAssigneesStoreState) => {
  return {
    assignees: state.assignees.map,
  };
};

export class ActionCtrl extends GtmhubController implements IController {
  id: string;
  ids: string[];
  type: "send-email" | "send-emails";
  assignees: IdMap<IAssignee>;

  static $inject = ["$window", "$q", "$ngRedux", "AssigneeActions", "TeamService", "UIErrorHandlingService"];

  constructor(
    private $window: IWindowService,
    private $q: IQService,
    $ngRedux: INgRedux,
    assigneeActions: AssigneeActions,
    private teamService: TeamService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    super();

    this.onDestroy($ngRedux.connect(bindStateToCtrl)(this));
    $ngRedux.dispatch(assigneeActions.getAssignees());
  }

  sendEmail(): void {
    this.processEmails([this.id]).then((emails) => {
      this.$window.open("mailto:" + emails.join(";"), "_self");
    });
  }

  sendEmails(): void {
    this.processEmails(this.ids).then((emails) => {
      this.$window.open("mailto:" + emails.join(";"), "_self");
    });
  }

  private processEmails(ids: string[]): IPromise<string[]> {
    const allEmails: Set<string> = new Set();
    const teamsPromiseMap: { [id: string]: IPromise<ITeam> } = {};

    for (const id of ids) {
      const owner = this.assignees[id];
      if (owner && owner.type === "team") {
        teamsPromiseMap[owner.id] = this.teamService.getTeam(id);
      }
    }

    return this.$q.all(teamsPromiseMap).then(
      (teamsMap) => {
        for (const id of ids) {
          const owner = this.assignees[id];

          if (owner) {
            if (owner.type === "user") {
              this.appendUserEmail(owner.id, allEmails);
            } else {
              const team = teamsMap[owner.id];

              if (team.members) {
                team.members.forEach((memberId) => this.appendUserEmail(memberId, allEmails));
              }

              if (team.manager) {
                this.appendUserEmail(team.manager, allEmails);
              }
            }
          }
        }

        return this.$q.resolve([...allEmails]);
      },
      (err) => {
        this.uiErrorHandlingService.handleModal(err);
        return this.$q.resolve([]);
      }
    );
  }

  private appendUserEmail(userId: string, allEmails: Set<string>): void {
    const user = this.assignees[userId];

    if (!user) {
      return console.warn(`Such user does not exist. USER ID: ${userId}`);
    }

    if (!user.email) {
      return console.warn(`This user doesn't have an email. USER ID: ${user.id}`);
    }

    allEmails.add(user.email);
  }
}

export const ActionComponent: IComponentOptions = {
  controller: ActionCtrl,
  templateUrl: require("./action.jade"),
  bindings: {
    id: "@",
    ids: "<",
    type: "@",
  },
};
